import type { ReactNode } from 'react'
import { Outlet } from 'react-router'
import { NotFoundView } from '#src/components/NotFoundView.js'
import { fetchPageMeta, getClients, getServicePageData } from '#src/data/data.js'
import { languageService } from '#src/languageService.js'
import { PostProduction } from '#src/pages/services/post-production/PostProduction.js'
import { mergeMeta } from '#src/seo.js'
import type { Route } from './+types/post-production.route.js'

export async function loader({ request }: Route.LoaderArgs) {
  const lang = languageService.langFromRequest(request)
  const [data, clients, meta] = await Promise.all([
    getServicePageData('postProductionPage', lang),
    getClients(),
    fetchPageMeta('postProductionPage', lang, '/services/post-production'),
  ])
  return { data, clients, meta }
}

export function meta({ loaderData, matches }: Route.MetaArgs): Route.MetaDescriptors {
  return mergeMeta(matches[0].meta, loaderData?.meta || [])
}

export default function PostProductionLayout({ loaderData }: Route.ComponentProps): ReactNode {
  if (!loaderData.data) {
    return <NotFoundView />
  }

  return (
    <PostProduction data={loaderData.data} clients={loaderData.clients}>
      <Outlet />
    </PostProduction>
  )
}
